export default __webpack_public_path__ + "static/lockup_equipment_upgrade-cf562b59265bcf8c0d3897df56d846a7.png";